import { useState, useEffect } from 'react';
import { useAuth } from '@context/auth-context';

import type { TopBarProps } from '@component/layout/types';

export default function TopBar({ onLogout }: TopBarProps) {
  const { user } = useAuth();
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const close = (e: MouseEvent) => {
      const target = e.target as HTMLElement | null;
      if (!target?.closest('.avatar') && !target?.closest('.umenu')) setMenuOpen(false);
    };
    document.addEventListener('click', close);
    return () => document.removeEventListener('click', close);
  }, []);

  return (
    <div className="topbar" style={{ position: 'relative' }}>
      <div className="tb-l">
        <div className="tb-icon">
          <img src="/img/Final_IWRPP_Logo-removebg-preview (3) 1.png" alt="" style={{ width: '100%' }} />
        </div>
        <div>
          <div className="tb-title">Project Performance Monitoring Dashboard</div>
          {user?.role !== 'gap' && (
            <div className="tb-sub">
              IWRPP · Industries, Commerce &amp; Investment Department — COE Programme
            </div>
          )}
        </div>
      </div>
      <div className="tb-r">
        <div className="avatar" onClick={() => setMenuOpen((o) => !o)}>
          {(user?.name || 'AH').slice(0, 2).toUpperCase()}
        </div>
      </div>
      <div className={`umenu${menuOpen ? ' open' : ''}`}>
        <div className="um-hd">
          <div className="um-name">{user?.name || 'Admin Hassan'}</div>
          <div className="um-role">
            {user ? `${user.roleLabel} · ${user.email}` : 'PIU Administrator · admin@piu.gov.pk'}
          </div>
        </div>
        <div className="um-item"> My Profile</div>
        <div className="um-item danger" onClick={onLogout}>
          {' '}
          Sign Out
        </div>
      </div>
    </div>
  );
}
